import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { ThunkAPI } from '../rootReducer';
import { basicApiAsyncThunkCreator } from '../../services/apiAsyncThunkCreator';
import { HttpMethods, SERVICES } from '../../services/api';
import { setAccountUsage } from '.';
import { AccessTypes } from '../../components/common/domain/accountAccessType';
import { showErrorMessage } from '../notifications';

export interface IAccountUsageResponse {
  usage: number;
}

export interface IAccountUsagePayload {
  accessType: string;
}

export const getAccountUsageForUser: AsyncThunk<IAccountUsageResponse, IAccountUsagePayload, ThunkAPI> = createAsyncThunk(
  'account/usage',
  async (data, thunk) => {
    try {
      const serviceUrl = data.accessType === AccessTypes.Lite ? SERVICES.EXPORT_IMPORT_SERVICE_LITE : SERVICES.EXPORT_IMPORT_SERVICE_GLOBAL;
      const response = await basicApiAsyncThunkCreator<IAccountUsageResponse, undefined>({
        endpoint: 'account/usage',
        microservice: serviceUrl,
        authenticated: true,
        method: HttpMethods.Get,
        contentType: 'application/json'
      })(undefined, thunk);
      if('usage' in response) {
        thunk.dispatch(setAccountUsage(response.usage));
      }
      return response;
    } catch (err) {
      thunk.dispatch(showErrorMessage('Your request failed, please try again later or contact support'));
      return thunk.rejectWithValue(err);
    }
  }
);